import WebGalleryNoAccess from './WebGalleryNoAccess';

export default WebGalleryNoAccess;
